module.exports = "<svg viewbox=\"0 0 8 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.937 2.752h1.891V.01L5.223 0c-2.893 0-3.55 2.047-3.55 3.353v1.829H0v2.824h1.673V16H5.19V8.006h2.375l.308-2.824H5.19v-1.66c0-.624.44-.77.747-.77\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/video-js-core/src/sharing/icons/fbFeed.svg
// module id = 610
// module chunks = 0